import Vue from 'vue'
import App from './App.vue'
import './plugins/cookie'
import router from './router'
import './plugins/axios'
import store from './store'
import './plugins/element.js'

import HighchartsVue from 'highcharts-vue'
// import axios from "axios"

Vue.use(HighchartsVue)
// Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
